/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';

import './TitleBar.scss';

/**
 * @group Components
 * Displays article titles
 */

const TitleBar = (props) => {
  const { opts } = props;
  const { options } = opts;
  return (
    <div className="title howto-titleBar grid">
      <div className="skills col-1-2">
        {
          options.level && <span className={`difficulty ${options.level}`} />
        }
        {
          options.duration && <span className={`duration ${options.duration}`}>{options.duration}</span>
        }
      </div>
      <div id="socialWidgetTable" className="col-1-2 widgetEmailPrintTable div-right">
        {
          options.print && <div className="widget"><a href="javascript:window.print();" name="print-page"><i className="dwarf-printIcon" /></a></div> /* eslint-disable-line */
        }
        {
          // eslint-disable-next-line max-len
          options.pdf && <div className="widget"><a href={options.URL} name="pdf-page"><i className="icon-pdfIcon" /></a></div>
        }
      </div>
    </div>
  );
};

TitleBar.propTypes = {
  opts: PropTypes.shape({
    options: PropTypes.shape({
      stepCount: PropTypes.string,
      text: PropTypes.string,
      name: PropTypes.string,
      Content: PropTypes.object,
      level: PropTypes.string,
      URL: PropTypes.string,
      duration: PropTypes.string,
      pdf: PropTypes.string,
    }),
    Content: PropTypes.object,
  }).isRequired

};

export default TitleBar;
